export default {
  header: "",
  children: [
    {
      id: "profile",
      title: "Профиль",
      iconSvg: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> \
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8445 21.6623C8.15273 21.6623 5 21.0878 5 18.787C5 16.4862 8.13273 14.3623 11.8445 14.3623C15.5364 14.3623 18.6891 16.4657 18.6891 18.7664C18.6891 21.0663 15.5564 21.6623 11.8445 21.6623Z" stroke="#636E72" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> \
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8375 11.174C14.2602 11.174 16.2239 9.21039 16.2239 6.78766C16.2239 4.36494 14.2602 2.40039 11.8375 2.40039C9.41477 2.40039 7.45022 4.36494 7.45022 6.78766C7.44204 9.20221 9.39204 11.1658 11.8066 11.174C11.8175 11.174 11.8275 11.174 11.8375 11.174Z" stroke="#636E72" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> \
      </svg>',
      card: "profile",
    },
    {
      id: "stats",
      title: "Статистика",
      iconSvg: '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> \
      <path d="M5.98286 9.26074V15.9544" stroke="#0010F7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> \
      <path d="M10.5366 6.05713V15.955" stroke="#0010F7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> \
      <path d="M15.0156 12.7979V15.9547" stroke="#0010F7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> \
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.799805 11.0366C0.799805 3.73454 3.23454 1.2998 10.5366 1.2998C17.8388 1.2998 20.2735 3.73454 20.2735 11.0366C20.2735 18.3388 17.8388 20.7735 10.5366 20.7735C3.23454 20.7735 0.799805 18.3388 0.799805 11.0366Z" stroke="#0010F7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> \
      </svg>',
      card: "stats",
      onlyAdmin: true,
    },
    {
      id: "pricing",
      title: "Тарифный план",
      iconSvg: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.75 10C0.75 3.063 3.063 0.75 10 0.75C16.937 0.75 19.25 3.063 19.25 10C19.25 16.937 16.937 19.25 10 19.25C3.063 19.25 0.75 16.937 0.75 10Z" stroke="#636E72" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\
      <path d="M7.42969 12.5697L12.5697 7.42969" stroke="#636E72" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\
      <path d="M12.4955 12.5H12.5045" stroke="#636E72" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\
      <path d="M7.4955 7.5H7.5045" stroke="#636E72" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\
      </svg>',
      card: "pricing",
    },
    {
      id: "billing",
      title: "Биллинг",
      iconSvg: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> \
      <path d="M21.1712 14.6755H17.2845C15.8693 14.6755 14.7217 13.5279 14.7217 12.1117C14.7217 10.6964 15.8693 9.54883 17.2845 9.54883H21.1407" stroke="#0010F7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\
      <path d="M17.7214 12.0543H17.4243" stroke="#0010F7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\
      <path d="M7.60645 8.14416H11.6664" stroke="#0010F7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.71387 12.2539C2.71387 5.84913 5.03863 3.71484 12.0148 3.71484C18.9901 3.71484 21.3148 5.84913 21.3148 12.2539C21.3148 18.6577 18.9901 20.7929 12.0148 20.7929C5.03863 20.7929 2.71387 18.6577 2.71387 12.2539Z" stroke="#0010F7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\
      </svg>',
      card: "billing",
    },
  ]
}